import { render, staticRenderFns } from "./LegalPageWrapper.vue?vue&type=template&id=db2820be&scoped=true&"
import script from "./LegalPageWrapper.vue?vue&type=script&lang=ts&"
export * from "./LegalPageWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./LegalPageWrapper.vue?vue&type=style&index=0&id=db2820be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2820be",
  null
  
)

export default component.exports